<div class="bmc-ai-jobs-list">
  <h4 class="bz-font-weight--semibold">{{'AIJOBS.AIJOB_LIST' | translate}}</h4>
  <div class="bmc-ai-jobs-list__search-box bz-border-radius--m">
    <bzg-input [placeholder]="('AIJOBS.SEARCH' | translate)" class="bmc-ai-jobs-list__search-box__text"
      name="search-box" [(ngModel)]="searchValue" actionIcnPosition="right">
      <bzg-icon nameIcon="icon-search"></bzg-icon>
    </bzg-input>
  </div>
  <ul class="bmc-ai-jobs-list__items">
    <li class="bmc-ai-jobs-list__item bz-shadow--xs bz-border-radius--m"
      [ngClass]="{'bz-color-bg--theme-100': userJob === selectedJob}"
      *ngFor="let userJob of userJobs | AIJobsList:searchValue" (click)="setCurrentJob(userJob)">
      <h5 class="bz-font-weight--semibold">{{userJob.name}}</h5>
      <div *ngIf="userJob.enabled">
        <h5 class="bmc-ai-jobs-list__item__middle-text bz-font-size--body-small">
          <span *ngIf="!isNextRuntimeYear9999(userJob)">
            {{'AIJOBS.NEXT_RUN_TIME' | translate}}: {{userJob.nextRuntime | showDateFormat: 10}}
          </span>
          <svg class="bz-icn bz-icon-svg--16" *ngIf="!isNextRuntimeYear9999(userJob)">
            <use href="#icon-arrow-right-bold"></use>
          </svg>
        </h5>
        <h5
          class="bmc-ai-jobs-list__item__bottom-text bz-font-style--italic bz-font-size--body-small bz-color--theme-400">
          {{ 'AIJOBS.ENABLED' | translate}}
          <svg class="bz-icn bz-icon-svg--16" *ngIf="isNextRuntimeYear9999(userJob)">
            <use href="#icon-arrow-right-bold"></use>
          </svg>
        </h5>
      </div>
      <div *ngIf="!userJob.enabled">
        <h5 class="bmc-ai-jobs-list__item__middle-text bz-font-size--body-small">
          {{'AIJOBS.LAST_EXECUTED_TIME' | translate}}:
          <span class="bmc-ai-jobs-list__item__middle-text-space" *ngIf="userJob.lastProcessingTime"> {{userJob.lastProcessingTime | showDateFormat: 1}}</span>
          <span class="bmc-ai-jobs-list__item__middle-text-space" *ngIf="!userJob.lastProcessingTime"> {{'USERJOBS.NOT_EXECUTED' | translate}}</span>
          <svg class="bz-icn bz-icon-svg--16">
            <use href="#icon-arrow-right-bold"></use>
          </svg>
        </h5>
        <h5
          class="bmc-ai-jobs-list__item__bottom-text bz-font-style--italic bz-font-size--body-small bz-color--neutral-400">
          {{ 'USERJOBS.DISABLED' | translate}}
        </h5>
      </div>
    </li>
  </ul>
</div>
